module.exports = __webpack_public_path__ + "img/recalculate-icon.aa977505.svg";